import axios, { AxiosInstance } from 'axios';
import { config } from '../config/config';
import { setupGlobalErrorHandler } from './globalErrorHandler';
import { getClientTelemetryHeaders } from '../telemetry';

let readToken: (doNotRenewToken?: boolean) => Promise<string | undefined>;

let axiosInstance: AxiosInstance | undefined = undefined;
export const getAxiosInstance = () => {
  if (axiosInstance) {
    return axiosInstance;
  } else if (config.NX_PUBLIC_API_URL) {
    axiosInstance = axios.create({
      baseURL: config.NX_PUBLIC_API_URL,
    });

    setupGlobalErrorHandler(axiosInstance);

    // Ensure telemetry headers are present even if callers bypass the wrapper helpers.
    axiosInstance.interceptors.request.use(async (request) => {
      const telemetryHeaders = await getClientTelemetryHeaders({
        method: request.method,
        url: request.url,
        baseURL: request.baseURL,
      });
      // Prefer any explicitly set headers (e.g. wrapper-provided correlation id).
      request.headers = {
        ...telemetryHeaders,
        ...(request.headers as unknown as Record<string, string> | undefined),
      };
      return request;
    });

    return axiosInstance;
  }
  return undefined;
};

let openAxiosInstance: AxiosInstance | undefined = undefined;
export const getOpenAxiosInstance = () => {
  if (openAxiosInstance) {
    return openAxiosInstance;
  } else if (config.NX_PUBLIC_OPEN_API_URL) {
    openAxiosInstance = axios.create({
      baseURL: config.NX_PUBLIC_OPEN_API_URL,
    });

    setupGlobalErrorHandler(openAxiosInstance);

    // Same telemetry behavior for open API calls.
    openAxiosInstance.interceptors.request.use(async (request) => {
      const telemetryHeaders = await getClientTelemetryHeaders({
        method: request.method,
        url: request.url,
        baseURL: request.baseURL,
      });
      request.headers = {
        ...telemetryHeaders,
        ...(request.headers as unknown as Record<string, string> | undefined),
      };
      return request;
    });

    return openAxiosInstance;
  }
  return undefined;
};

export const setReadTokenMethod = (
  _readToken: (doNotRenewToken?: boolean) => Promise<string | undefined>
) => {
  readToken = _readToken;
};

const getToken = async (doNotRenewToken?: boolean) => {
  return await readToken(doNotRenewToken);
};

export { getToken };
